import { FC } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

import { AUiConfig } from 'store/config';
import { AIsOpenInfoBanner } from 'store/infoBanner';
import { AProjectConfigs } from 'store/projectConfigs';
import { ACountry } from 'store/init';

import { infoData } from 'constants/infoData';

import gameManager from "../../api/gameManager/GameManager";

import {
  SContainer,
  SWrapper,
  SInfoWrapper,
  SCloseBtn,
  SLogo,
  STitle,
  SSubInfo,
  SSubText,
  SSubTitle,
  SContent,
  SComponentImg,
  SBtnWrapper,
  SInfoItem,
  SLastTitle,
  SContentSubTitle,
  SContentInfo,
  SContentTitle,
} from './style';

const InfoBanner: FC = () => {
  const { t } = useTranslation();
  const setIsOpenInfoBanner = useSetRecoilState(AIsOpenInfoBanner);
  const { logo } = useRecoilValue(AProjectConfigs);
  const country = useRecoilValue(ACountry);
  const hideInfoHandler = () => setIsOpenInfoBanner(false);
  const { disableAutobet, disableAutocollect } = useRecoilValue(AUiConfig);

  const createTranslation = (literal: string, country?: string) => {
    if (!country) {
      return parseText(t(literal));
    }

    const nl = `${literal}-${country}`;
    const cl = parseText(t(nl));

    return cl === nl ? parseText(t(literal)) : cl;
  };

  const parseText = (text: string) : string => {
    text = text.replace("{min_bet}", gameManager.getCurrency() + gameManager.getMinBet().toFixed(2))
      .replace("{max_bet}", gameManager.getCurrency() + gameManager.getMaxBet().toFixed(2))
      .replace("{max_win}",  gameManager.getCurrency() +gameManager.getMaxWin().toFixed(2));
    return text;
  }

  const check = (checkValue?: string, equalTo?: string): boolean => {

    switch (checkValue) {
      case 'autoBet':
        return !disableAutobet;
      case 'autoCollect':
        return !disableAutocollect;
      case 'country':
        return country === equalTo
      default:
        return true;
    }
  };

  return (
    <SContainer>
      <SWrapper>
        <SInfoWrapper className="no-scrollbars">
          <SLogo src={logo} />
          <STitle>{createTranslation('information', country)}</STitle>
          <SSubInfo>
            <SSubTitle>{createTranslation('rtp', country)}</SSubTitle>
            <SSubText>{createTranslation('infoSubTitle', country)}</SSubText>
          </SSubInfo>
          <SContent>
            {infoData.map(
              ({ id, infoText, title, content, lastTitle, checkValue, checkValueEquals }) =>
                check(checkValue, checkValueEquals) ? (
                  <SInfoItem key={id}>
                    {
                      createTranslation(title, country) != "" && (
                        <SContentTitle>
                          {createTranslation(title, country)}
                        </SContentTitle>
                      )
                    }

                    {
                      createTranslation(infoText, country) != "" && (
                        <SContentInfo>
                          {createTranslation(infoText, country)}
                        </SContentInfo>
                      )
                    }

                    {lastTitle && createTranslation(lastTitle, country) != "" && (
                      <SLastTitle>
                        {createTranslation(lastTitle, country)}
                      </SLastTitle>
                    )}

                    {content &&
                      content.filter((item) => {
                        //Filter out items that are hidden when cancel bet is disabled.
                        return item.dcb != !gameManager.cancelButtonDisabled()
                      }).map(
                        ({ id, subTitle, pathImg, isFullWidth, text ,dcb}) => {
                          console.log(subTitle)

                          return (
                            <SInfoItem key={id}>
                              {createTranslation(subTitle, country) != "" && (
                                <SContentSubTitle>
                                  {createTranslation(subTitle, country)}
                                </SContentSubTitle>
                              )}
                              {pathImg && createTranslation(pathImg, country) != "" && (
                                <SComponentImg
                                  isFullWidth={isFullWidth}
                                  src={createTranslation(pathImg, country)}
                                />
                              )}
                              {createTranslation(text, country) != "" && (
                                <SContentInfo>
                                  {createTranslation(text, country)}
                                </SContentInfo>
                              )}
                            </SInfoItem>
                          );
                        },
                      )}
                  </SInfoItem>
                ) : (
                  <></>
                ),
            )}
          </SContent>
        </SInfoWrapper>
        <SBtnWrapper>
          <SCloseBtn onClick={hideInfoHandler}>{t('close')}</SCloseBtn>
        </SBtnWrapper>
      </SWrapper>
    </SContainer>
  );
};

export default InfoBanner;
